import { Dialog } from 'primereact/dialog';
import classes from './summary.module.scss';
import { Button } from 'primereact/button';

const SummaryModal = ({
  visibility,
  toggleVisibility,
  planningMonths,
  getSalesplanValue,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
  planningMonths: { label: string; dateString: string }[];
  getSalesplanValue: (
    cot: string,
    cat: string,
    planningPeriod: string,
    need: string
  ) => string | number | null;
}) => {
  const cots: { cot: string; value: string }[] = [
    { value: 'cmop', cot: 'CMOP' },
    { value: 'va facility', cot: 'VA Facility' },
    { value: 'tmop', cot: 'TMOP' },
    { value: 'mtf', cot: 'MTF' },
  ];

  return (
    <Dialog
      visible={visibility}
      style={{ width: '75vw' }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
      headerStyle={{ display: 'none' }}
      contentStyle={{ padding: '0', margin: '0', borderRadius: '10px' }}
      closable={false}
    >
      <div className={classes.headingContainer}>
        <h3>Direct</h3>
      </div>
      {/* direct table start */}
      <div className={classes.tableContainer}>
        <table>
          <thead>
            <td>COT</td>

            {planningMonths.map(month => {
              return <td>{month.label}</td>;
            })}
          </thead>
          <tbody>
            {cots.map(item => {
              return (
                <tr>
                  <td>{item.cot}</td>
                  {planningMonths.map(month => {
                    return (
                      <td>
                        {getSalesplanValue(item.value, 'direct', month.dateString, 'euforecast')}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* direct table end */}

      <div className={classes.headingContainer} style={{ marginTop: '1rem' }}>
        <h3>Indirect</h3>
      </div>
      {/* indirect table start */}
      <div className={classes.tableContainer}>
        <table>
          <thead>
            <td>COT</td>
            {planningMonths.map(month => {
              return <td>{month.label}</td>;
            })}
          </thead>
          <tbody>
            {cots.map(item => {
              return (
                <tr>
                  <td>{item.cot}</td>
                  {planningMonths.map(month => {
                    return (
                      <td>
                        {getSalesplanValue(item.value, 'indirect', month.dateString, 'euforecast')}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* indirect table end */}

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={toggleVisibility} className={classes.cancelButton}>
          Cancel
        </Button>
      </div>
    </Dialog>
  );
};

export default SummaryModal;
